var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-block bg-white"},[_c('h4',[_vm._v("Transaction History")]),_c('block-activity',{attrs:{"activity":_vm.activity}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }